var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.986 25.1188C16.0173 25.5387 16.2058 25.9313 16.514 26.2182C16.8221 26.5051 17.2271 26.6652 17.6482 26.6666H23.3571C23.7781 26.6652 24.1831 26.5051 24.4913 26.2182C24.7994 25.9313 24.988 25.5387 25.0193 25.1188L25.5437 17.7777H15.4615L15.986 25.1188Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6137 15.5555H23.2804V13.8888C23.2804 13.7415 23.2219 13.6002 23.1177 13.496C23.0135 13.3918 22.8722 13.3333 22.7248 13.3333H18.2804C18.133 13.3333 17.9917 13.3918 17.8875 13.496C17.7834 13.6002 17.7248 13.7415 17.7248 13.8888V15.5555H14.3915C14.2442 15.5555 14.1028 15.614 13.9987 15.7182C13.8945 15.8224 13.8359 15.9637 13.8359 16.111C13.8359 16.2584 13.8945 16.3997 13.9987 16.5039C14.1028 16.6081 14.2442 16.6666 14.3915 16.6666H26.6137C26.7611 16.6666 26.9024 16.6081 27.0066 16.5039C27.1107 16.3997 27.1693 16.2584 27.1693 16.111C27.1693 15.9637 27.1107 15.8224 27.0066 15.7182C26.9024 15.614 26.7611 15.5555 26.6137 15.5555ZM18.8359 14.4444H22.1693V15.5555H18.8359V14.4444Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.84377ad565e349346fc07a323912242c.svg";
export { ForwardRef as ReactComponent };